import React from "react";
import Theme from "@adsk/alloy-react-theme";
import { MenuItem } from "@adsk/alloy-react-dropdown";
import { DropdownOption } from "@adsk/acc-issues-common/types/dropdown";
import { StylableComponent } from "@adsk/alloy-react-theme";
import { PlacementEntityType } from "./types";
import { usePlacementFlow } from "./usePlacementFlow";

export const PlacementDropdownMenuItem = ({
  option,
  props,
}: {
  option: DropdownOption<PlacementEntityType>;
  props: StylableComponent<HTMLLIElement> & { disabled?: boolean };
}) => {
  const { getIconForEntityType } = usePlacementFlow();
  const Icon = getIconForEntityType(option.value);

  return (
    <MenuItem
      {...props}
      style={{
        display: "flex",
        alignItems: "center",
      }}
      text={option.label}
      renderLeftComponent={() => (
        <Icon
          size={20}
          style={{
            marginRight: 6,
            color: props.disabled ? Theme.colors.charcoal500 : "",
          }}
        />
      )}
    />
  );
};
